module.exports = __webpack_public_path__ + "static/family1-dda04116837b10da339eaea7c2281138.jpg";